<template>
  <v-card class="px-2 pb-2 mb-3">
    <v-card-title primary-title>
      <span class="title">Balances</span>
    </v-card-title>
    <v-container fluid>
      <v-layout pt-3>
        <v-autocomplete class="ml-0" 
          v-model="selected"
          :options="items"
          :items="items" 
          item-text="nameClient"
          cache-items
          label="Select a sheet"  
        ></v-autocomplete>
        <v-btn 
          color="green" 
          class="ml-3" 
          :loading="loading"
          @click=refreshSheet(selected)
        > Refresh </v-btn> 
        <v-btn 
          color="blue"
          class="ml-3"
          :loading="loading"
          :href="url(selected)"
          target="_blank"
        > View Sheet </v-btn>
      </v-layout> 
    </v-container>
  </v-card>
</template>

<script>
import MongoService from '../../services/mongo.service'
import MongoConnector from '@/services/mongo-connector.service'
import MessageDialog from '../../libs/message-dialog/'


export default {
    data() {
      const service = new MongoConnector(null, 'spreadsheet-balance-report-configs', {})
      return {
        service,
        loading: false,
        selected: {},
        items: [],
        }
      },
    async beforeMount () {
      this.loading = true
      try {
        let result = await this.service.find({ limit: 100 , sort: { nameClient: 1, balance_tab_id: 1 }})
        result = result.map(x => {
          return {
            sheet_id: x.sheet_id,
            nameClient: x.name,
            tab_id: x.balance_tab_id
          }
        })
        this.items.push(...result)
      } catch (e) { console.log(e) }
      this.loading = false
    }, computed: {
    value() {
      return (item) => {
        return {
          sheet_id: item.sheet_id,
          tab_id: item.tab_id,
          nameClient: item.name
        }
      }
    }
    },
    methods: {
      url (nameClient) {
        const matchingItems = this.items.filter(item => item.nameClient === nameClient)
        if (matchingItems.length) {
          return `https://docs.google.com/spreadsheets/d/${matchingItems[0].sheet_id}/view#gid=${matchingItems[0].tab_id}`
        }
      },
      async refreshSheet (nameClient) {
        this.loading = true
        if (typeof name === 'string') {
        try {
          const result = await MongoService.spreadsheetOperation.refreshBalances({ name: nameClient })
          if (result.statusCode === 200) {
            MessageDialog.showSuccessMessage({ title: nameClient , text: 'Spreadsheet Refresh Complete'})
          } else {
              MessageDialog.showErrorMessage({ title: nameClient, text: result.body })
            }
        } catch (error) {
          console.log('UpdateBalances Error: ', error)
          MessageDialog.showErrorMessage({ text: error })
        }
      } else {
      MessageDialog.showErrorMessage({ text: 'Please Select Client' })
      this.loading = false
      }
    }
      }
  }
</script>
